import React, { useMemo, useState } from 'react';
import { Card, CardBody, Col, Container, Button } from 'reactstrap';
import DataTable, { TableColumn } from 'react-data-table-component';
import { useNavigate, Link } from 'react-router-dom';
import { useIteamResource } from '../../../hook/ShowTable/generic';
import FilterComponent from '../../../Components/Tables/DataTables/Common/FilterComponent';
import Loader from '../../../Components/Widgets/Loader/generic';
import { Btn } from '../../../AbstractElements';
import DeleteConfirm from '../../../Components/Modals/Delete'
import Favourite from '../../../Components/Widgets/Favourite'

export interface Cluster {
  ID: number;
  campo: string | number | null;
  groupName: string
}

type ApiResponse = {
  message: {
    status: string;
    list: Cluster[];
  };
};


const CAMPO_LABELS: Record<string, string> = {
  new_cluster_clienteling_h2_25_frh: 'Clienteling',
  generational_cluster: 'General Cluster',
  behavioural_cluster: 'Behavioural Cluster',
  segm1_frequency: 'Frequency',
};


// Helper 
const getCampoLabel = (value: Cluster['campo']) => {
  if (value === null || value === undefined) return '';
  const key = String(value);
  return CAMPO_LABELS[key] ?? key;
};


export default function Index() {
  const [filterText, setFilterText] = useState('');
  const [reloadKey, setReloadKey] = useState(0);
  const { data: payload, loading } =
    useIteamResource<ApiResponse>(`/cluster/list?rk=${reloadKey}`);


  const rows: Cluster[] = useMemo(
    () => (Array.isArray(payload?.message?.list) ? payload!.message.list : []),
    [payload]
  );

  const filteredRows = useMemo(() => {
    if (!filterText) return rows;
    const q = filterText.toLowerCase();
    return rows.filter((r) => {
      const campoLabel = getCampoLabel(r.campo).toLowerCase();
      const gruppo = (r.groupName ?? '').toLowerCase();
      return campoLabel.includes(q) || gruppo.includes(q);
    });
  }, [rows, filterText]);

  const columns: TableColumn<Cluster>[] = useMemo(() => [
    {
      name: 'Gruppo',
      cell: (row) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ display: 'inline-block' }} />
          {row.groupName}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Campo',
      selector: (row) => getCampoLabel(row.campo), // 👈 ritorna SEMPRE string (Primitive)
      sortable: true,
    },
    {
      name: 'Azioni',

      cell: (row) => {
        const slug = encodeURIComponent(String(row.groupName));
        return (
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="sm"
              color="primary"
              tag={Link as any}
              to={`/configurazione/cluster/${slug}`}
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
            >
              Modifica
            </Button>
            <DeleteConfirm
              url={`/cluster?groupName=${row.groupName}&user_email=${encodeURIComponent(localStorage.getItem('email') || '')}`}
              onSuccess={() => setReloadKey(k => k + 1)}
              trigger={
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  title="Elimina"
                >
                  Elimina
                </button>
              }
            />
          </div>
        )
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '280px',
    },
  ], []);

  return (
    <Container fluid className="p-3">
      <Card>
        <CardBody>
          <Col xl={12} className="mb-lg-3 d-flex justify-content-end">
            <div className='d-flex gap-2'>
              <Favourite
                percorso={'/configurazione/cluster'}
                nome={'Gestione Cluster'}
              />
              <Link to="/configurazione/cluster/new">
                <Btn className="px-4" color="primary" type="button">
                  NUOVO
                </Btn>
              </Link>
            </div>
          </Col>
          <DataTable<Cluster>
            data={filteredRows}
            columns={columns}
            keyField="groupName"   // opzionale ma utile se non hai un id
            progressPending={loading}
            progressComponent={<Loader />}
            pagination
            striped
            highlightOnHover
            className="display"
          />
        </CardBody>
      </Card>
    </Container>

  );
}
